import React, { useState } from "react";
import { useTheme } from "@material-ui/core/styles";
import { Box, MobileStepper, Button, Paper } from "@material-ui/core";

// import SwipeableViews from "react-swipeable-views";

import { withStyles } from "@material-ui/core/styles";

import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";

const ChartStepper = withStyles((theme) => ({
  root: {
    backgroundColor: "unset",
    placeContent: "center",
    paddingBottom: 0,
  },
  dot: {
    backgroundColor: theme.palette.primary.light,
  },
  dotActive: {
    backgroundColor: theme.palette.secondary.light,
  },
}))(MobileStepper);

const ChartCard = withStyles((theme) => ({
  root: {
    height: "100%",
    overflow: "overlay",
  },
}))(Paper);

export default function ({ steps }) {
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => setActiveStep(() => activeStep + 1);
  const handlePrev = () => setActiveStep(() => activeStep - 1);
  // const handleChangeStep = setActiveStep;

  if (steps.length === 1) {
    return <ChartCard>{steps[activeStep]}</ChartCard>;
  }

  return (
    <Box flexBasis="auto" flexGrow={1} display="flex" flexDirection="column" style={{ height: "100%" }}>
      <Box style={{ overflow: "hidden", height: "100%" }}>
        <ChartCard>{steps[activeStep]}</ChartCard>
        {/* <SwipeableViews

          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={activeStep}
          onChangeIndex={handleChangeStep}
          enableMouseEvents
        >
          {steps.map((step, idx) => (
            <ChartCard key={idx}>{step}</ChartCard>
          ))}
        </SwipeableViews> */}
      </Box>
      <Box pb={0} flexBasis={0}>
        <ChartStepper
          steps={steps.length}
          position="static"
          variant="dots"
          activeStep={activeStep}
          nextButton={
            <Button
              size="small"
              onClick={handleNext}
              disabled={activeStep === steps.length - 1}
            >
              {theme.direction === "rtl" ? (
                <KeyboardArrowLeft />
              ) : (
                <KeyboardArrowRight />
              )}
            </Button>
          }
          backButton={
            <Button
              size="small"
              onClick={handlePrev}
              disabled={activeStep === 0}
            >
              {theme.direction === "rtl" ? (
                <KeyboardArrowRight />
              ) : (
                <KeyboardArrowLeft />
              )}
            </Button>
          }
        />
      </Box>
    </Box>
  );
}

// const tutorialSteps = [
//   {
//     label: 'San Francisco – Oakland Bay Bridge, United States',
//     imgPath:
//       'https://images.unsplash.com/photo-1537944434965-cf4679d1a598?auto=format&fit=crop&w=400&h=250&q=60',
//   },
//   {
//     label: 'Bird',
//     imgPath:
//       'https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60',
//   },
//   {
//     label: 'Bali, Indonesia',
//     imgPath:
//       'https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250&q=80',
//   },
//   {
//     label: 'NeONBRAND Digital Marketing, Las Vegas, United States',
//     imgPath:
//       'https://images.unsplash.com/photo-1518732714860-b62714ce0c59?auto=format&fit=crop&w=400&h=250&q=60',
//   },
//   {
//     label: 'Goč, Serbia',
//     imgPath:
//       'https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60',
//   },
// ];

// const useStyles = makeStyles((theme) => ({
//   root: {
//     height: "100%",
//     maxWidth: 400,
//     flexGrow: 1,
//   },
//   stepper: {
//     textAlign: "center",
//     height: "20%"
//   },
//   header: {
//     display: 'flex',
//     alignItems: 'center',
//     height: "20%",
//     paddingLeft: theme.spacing(4),
//     backgroundColor: theme.palette.background.default,
//   },
//   img: {
//     height: "60%",
//     maxWidth: 400,
//     overflow: 'hidden',
//     display: 'block',
//     width: '100%',
//   },
// }));

// export default function TextMobileStepper() {
//   const classes = useStyles();
//   // const theme = useTheme();
//   const [activeStep, setActiveStep] = React.useState(0);
//   // const maxSteps = tutorialSteps.length;

//   // const handleNext = () => {
//   //   setActiveStep((prevActiveStep) => prevActiveStep + 1);
//   // };

//   // const handleBack = () => {
//   //   setActiveStep((prevActiveStep) => prevActiveStep - 1);
//   // };

//   return (
//     <div className={classes.root}>
//       <Paper square elevation={0} className={classes.header}>
//         <Typography>{tutorialSteps[activeStep].label}</Typography>
//       </Paper>
//     </div>
//   );
// }
